<template>
  <div class="card_template_info_wrap">
    <div class="header">
      <el-button size="medium" @click="goBack">返回</el-button>
      <el-button size="medium" type="primary" @click="toEditCardModule">编辑</el-button>
    </div>
    <div class="card_template_info_box" :style="`height: ${windowHeight - 170}px;`">
      <div class="card_info_box">
        <div class="card_template">
          <div class="card_box"  :class="{'hengshu' : templateInfo.templateAxis==1}">
            <img :src="templateInfo.frontUrl" alt="">
          </div>
          <div class="card_side_name">正面</div>
        </div>
        <div class="card_template">
          <div class="card_box"  :class="{'hengshu' : templateInfo.templateAxis==1}">
            <img :src="templateInfo.backUrl" alt="">
          </div>
          <div class="card_side_name">反面</div>
        </div>
      </div>
    </div>
  </div>
</template>

<script>
  import windowResize from '@/mixins/windowResize';
  import {getIntegralCardTemplateInfoById} from '@/api/integralBank';

  export default {
    name: "cardTemplateInfo",
    data() {
      return {
        templateId: this.$route.query.templateId,
        templateInfo: {}
      }
    },
    mixins: [windowResize],
    created() {
      this.getIntegralCardTemplateInfoById();
    },
    methods: {
      goBack() {
        this.$router.go(-1);
      },
      toEditCardModule() {
        this.$router.push({path: 'cardTemplateAdd', query: {templateId: this.templateId}})
      },
      getIntegralCardTemplateInfoById() {
        getIntegralCardTemplateInfoById({id: this.templateId}).then(res => res.data).then(data => {
          if (data.code === 200 && data.result) {
            this.templateInfo = data.data;
          }
        });
      }
    }
  }
</script>

<style lang="scss" scoped>
  @import './../../styles/mixin';

  .card_template_info_wrap{
    padding: 12px;

    .header {
      padding-bottom: 10px;
      border-bottom: 1px solid #eee;
    }

    .card_template_info_box{
      @include scrollBar;
      .card_info_box{
        width: 810px;
        margin: 0 auto;
        padding-top: 30px;
        display: flex;
        .card_template{
          flex: 1;
          .card_box{
            position: relative;
            width: 182px;
            height: 273px;
            margin: 0 auto;
            border: 1px solid #f8f8f8;
            border-radius: 5px;
            overflow: hidden;
            img{
              display: block;
              width: 100%;
              height: 100%;
            }
          }
          .hengshu{
             height: 182px;
             width: 273px;
          }
          .card_side_name{
            height: 30px;
            line-height: 30px;
            margin-top: 5px;
            text-align: center;
            font-weight: bold;
          }
        }
      }
    }
  }
</style>



// WEBPACK FOOTER //
// src/views/integralBank/cardTemplateInfo.vue